import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  Chip,
  LinearProgress,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import ProfileMenu from './ProfileMenu';

const Header: React.FC = () => {
  const { isAuthenticated, user } = useAuth();

  // Safe percentage calculation to avoid division by zero
  const calculateUsagePercentage = (usage: number, limit: number): number => {
    if (!limit || limit <= 0 || !usage || usage < 0) return 0;
    return Math.min((usage / limit) * 100, 100);
  };

  return (
    <>
      <AppBar position="static">
          <Toolbar 
            disableGutters
            sx={{ 
              justifyContent: 'space-between',
              minHeight: '64px !important',
              width: '100%',
              px: 2,
              pr: 2 // Match left padding for balanced spacing
            }}
          >
            {/* Left section - Logo and navigation */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant="h6"
                noWrap
                component={RouterLink}
                to="/"
                sx={{
                  mr: 2,
                  display: 'flex',
                  fontWeight: 700,
                  color: 'inherit',
                  textDecoration: 'none',
                }}
              >
                Interview Zen
              </Typography>
              
              {/* Documentation link */}
              <Button 
                color="inherit" 
                href="https://docs.interviewzen.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ ml: 1 }}
              >
                Docs
              </Button>
            </Box>

            {/* Right section - Usage quota and Profile or Auth buttons */}
            {isAuthenticated ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {/* Usage Quota Indicator */}
                {user?.monthlyUsage !== undefined && user?.monthlyLimit !== undefined && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 60, height: 4 }}>
                      <LinearProgress
                        variant="determinate"
                        value={calculateUsagePercentage(user.monthlyUsage, user.monthlyLimit)}
                        sx={{
                          height: 4,
                          borderRadius: 2,
                          backgroundColor: 'rgba(255, 255, 255, 0.3)',
                          '& .MuiLinearProgress-bar': {
                            borderRadius: 2,
                            backgroundColor: user.remainingUsage !== undefined && user.remainingUsage <= 5 ? '#ff5722' : 
                                            user.remainingUsage !== undefined && user.remainingUsage <= 10 ? '#ff9800' : '#4caf50'
                          }
                        }}
                      />
                    </Box>
                  </Box>
                )}
                <ProfileMenu user={user} />
              </Box>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button color="inherit" component={RouterLink} to="/login">
                  Login
                </Button>
                <Button color="inherit" component={RouterLink} to="/register">
                  Register
                </Button>
              </Box>
            )}
          </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;